// File: src/views/TermsOfUse.js

import React from 'react';
import LegalPage from '../components/legal/LegalPage';

function TermsOfUse() {
  return (
    <LegalPage title="Terms of Use" lastUpdated="March 1, 2026">

      <div className="highlight-box">
        <p>
          Please read these Terms of Use carefully before using the GreenScience
          website. By accessing or using our site, you agree to be bound by
          these terms.
        </p>
      </div>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing and using the GreenScience website located at{' '}
        <a href="https://www.greenscience.ca">www.greenscience.ca</a>{' '}
        (the "Site"), you accept and agree to be bound by these Terms of Use
        and our Privacy Policy. If you do not agree to these terms, please do
        not use the Site.
      </p>

      <h2>2. About GreenScience</h2>
      <p>
        GreenScience is a technology company developing AI-powered solutions
        to help businesses measure, manage, and reduce their environmental
        impact. The information provided on this Site is for general
        informational purposes only.
      </p>

      <h2>3. Intellectual Property</h2>
      <p>
        All content on this Site — including but not limited to text, graphics,
        logos, icons, images, audio clips, and software — is the property of
        GreenScience Inc. and is protected by applicable Canadian and
        international intellectual property laws.
      </p>
      <p>You may not:</p>
      <ul>
        <li>Reproduce, distribute, or publicly display any content without prior written consent</li>
        <li>Modify or create derivative works based on Site content</li>
        <li>Use any GreenScience trademarks or branding without explicit permission</li>
        <li>Scrape, crawl, or systematically extract data from the Site</li>
      </ul>

      <h2>4. Permitted Use</h2>
      <p>
        You may access and use the Site for lawful, personal, and
        non-commercial purposes. Specifically, you are permitted to:
      </p>
      <ul>
        <li>Browse and read publicly available content</li>
        <li>Share links to pages on the Site</li>
        <li>Contact us through our official contact channels</li>
        <li>Download materials explicitly made available for download</li>
      </ul>

      <h2>5. Prohibited Conduct</h2>
      <p>When using the Site, you agree not to:</p>
      <ul>
        <li>Violate any applicable local, provincial, national, or international law</li>
        <li>Transmit any unsolicited or unauthorised advertising or promotional material</li>
        <li>Attempt to gain unauthorised access to any part of the Site or its systems</li>
        <li>Interfere with or disrupt the integrity or performance of the Site</li>
        <li>Upload or transmit viruses or any other malicious code</li>
        <li>Impersonate any person or entity, or misrepresent your affiliation</li>
        <li>Collect or harvest personal information about other users</li>
      </ul>

      <h2>6. Disclaimer of Warranties</h2>
      <p>
        The Site and its content are provided on an <strong>"as is"</strong> and{' '}
        <strong>"as available"</strong> basis without any warranties of any kind,
        either express or implied. GreenScience does not warrant that:
      </p>
      <ul>
        <li>The Site will be uninterrupted, timely, secure, or error-free</li>
        <li>The results obtained from using the Site will be accurate or reliable</li>
        <li>Any errors in the Site will be corrected</li>
      </ul>

      <h2>7. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by applicable law, GreenScience Inc.,
        its directors, officers, employees, and agents shall not be liable for
        any indirect, incidental, special, consequential, or punitive damages
        arising from your use of, or inability to use, the Site or its content.
      </p>

      <h2>8. Third-Party Links</h2>
      <p>
        The Site may contain links to third-party websites. These links are
        provided for your convenience only. GreenScience has no control over
        the content of those sites and accepts no responsibility for them or
        for any loss or damage that may arise from your use of them.
      </p>

      <h2>9. Privacy</h2>
      <p>
        Your use of the Site is also governed by our{' '}
        <a href="/privacy-policy">Privacy Policy</a>, which is incorporated
        into these Terms of Use by reference. Please review our Privacy Policy
        to understand our practices.
      </p>

      <h2>10. Governing Law</h2>
      <p>
        These Terms of Use shall be governed by and construed in accordance
        with the laws of the Province of Ontario and the federal laws of Canada
        applicable therein, without regard to conflict of law principles.
      </p>

      <h2>11. Changes to These Terms</h2>
      <p>
        GreenScience reserves the right to modify these Terms of Use at any
        time. Changes will be effective immediately upon posting to the Site.
        Your continued use of the Site following any changes constitutes your
        acceptance of the revised terms. We encourage you to review these terms
        periodically.
      </p>

      <h2>12. Contact Us</h2>
      <p>
        If you have any questions about these Terms of Use, please contact us:
      </p>
      <ul>
        <li><strong>Email:</strong> <a href="mailto:legal@greenscience.ca">legal@greenscience.ca</a></li>
        <li><strong>Address:</strong> GreenScience Inc., Toronto, Ontario, Canada</li>
        <li><strong>Web:</strong> <a href="/contact">Contact Form</a></li>
      </ul>

    </LegalPage>
  );
}

export default TermsOfUse;